<template lang="pug">

    modal(ref='modal')
        span(slot="header") Lieferantenauswahl

        div(slot='content')

            //- Jobs
            .ui.section.horizontal.divider Lieferanten
            jobs-table(
                v-bind:offer-models="offerModels"
                v-bind:product-model="productModel"
                v-bind:supplier-models="supplierModels"
                v-bind:variant-models="variantModels"
                v-on:delete="onJobModelRemove"
                v-model="models"
            )

            //- Gültigkeitsdatum fuer neue Jobs
            .ui.form.right.aligned.grid.valid-until(v-show="showValidUntilField")
                .eight.wide.column
                    .inline.field: label Gültig bis
                .four.wide.column.right.floated
                    date-field(v-model="validUntilDate" v-bind:isRequired="true" format-to="Number")
                .four.wide.column
                    time-field(v-model="validUntilTime" v-bind:isRequired="true")

            //- Verfügbare Lieferanten
            .ui.section.horizontal.divider Verfügbare Lieferanten
            suppliers-table(
                v-bind:address-models="addressModels"
                v-bind:supplier-models="availableSuppliers"
                v-on:input="onSupplierAdd"
            )

        action-row(
            slot="footer"
            v-on:cancel="close()"
            v-on:save="persist()"
        )

</template>

<script>
    import * as R from 'ramda'
    import ActionRow from '@/components/form/ActionRow'
    import DateField from '@/components/form/DateField'
    import TimeField from '@/components/form/TimeField'
    import Modal from '@/components/app/Modal'
    import SuppliersTable from './update-form-modal/SuppliersTable'
    import JobsTable from './update-form-modal/JobsTable'

    export default {
        name: 'products-job-list-update-form-modal',

        components: { ActionRow, DateField, JobsTable, Modal, SuppliersTable, TimeField },

        computed: {

            availableSuppliers() {
                // Lieferanten zurueckgeben, die noch keinem Job zugewiesen sind
                return R.differenceWith(
                    (supplierModel, jobModel) => R.propEq('id', R.prop('supplier', jobModel), supplierModel),
                    this.supplierModels,
                    this.models
                )
            },

            showValidUntilField() {
                return R.any(R.propSatisfies(R.isNil, 'id'), this.models)
            }

        },

        data() {
            const tomorrow = new Date(Date.now() + (60 * 60 * 24 * 1000))

            return {
                validUntilDate: tomorrow.valueOf(),
                validUntilTime: { hours: 12, minutes: 0 },
                models: []
            }
        },

        methods: {

            close() {
                this.$refs.modal.close()
            },

            onJobModelRemove(jobModel) {
                // Job-Model aus Models entfernen
                this.models = R.reject(R.equals(jobModel), this.models)
            },

            onSupplierAdd(supplierModel) {
                const offerModels = R.map(
                    variantModel => ({ variant: R.prop('id', variantModel) }),
                    this.variantModels
                )

                this.models.push({
                    product: this.productModel.id,
                    supplier: supplierModel.id,
                    validUntil: this.validUntilDate,
                    offers: offerModels
                })
            },

            persist() {
                // Gültigkeits-Timestamp ermitteln
                const hours = this.validUntilTime.hours * 60000 * 60
                const minutes = this.validUntilTime.minutes * 60000
                const validUntilTimestamp = this.validUntilDate + hours + minutes

                // Neue Jobs speichern
                const persistNewJobs = R.compose(
                    // Promises zusammenfassen
                    promises => Promise.all(promises),

                    // Jobs speichern
                    R.map(jobModel => this.$store.dispatch('jobs/create', { model: jobModel })),

                    // Timestamp/Gültigkeit in Jobs setzen
                    R.map(R.assoc('validUntil', validUntilTimestamp)),

                    // Jobs ohne ID (noch nicht persistiert) filtern
                    R.filter(R.propSatisfies(R.isNil, 'id')),

                    // Job-Models holen
                    R.always(this.models)
                )

                // Neue Angebote speichern
                const persistNewOffers = R.compose(
                    // Promises zusammenfassen
                    promises => Promise.all(promises),

                    R.map(offerModel => this.$store.dispatch('offers/create', { model: offerModel })),

                    // Angebot filtern, die Objekte sind (noch nicht persistiert
                    R.filter(R.is(Object)),

                    // Angebote auslesen
                    R.chain(R.prop('offers')),

                    // Jobs mit ID (bereits persistiert) filtern
                    R.filter(R.propSatisfies(R.is(Number), 'id')),

                    // Job-Models holen
                    R.always(this.models)
                )

                Promise.all([ persistNewJobs(), persistNewOffers() ])

                    // Modal closen
                    .then(this.close)

                    // Erfolsmeldung anzeigen
                    .then(R.call(this.$growl.success, 'Anfragen wurden erstellt'))

                    // Fehlermeldung anzeigen
                    .catch(R.partial(this.$growl.fatal, ['Anfragen konnten nicht erstellt werden']))
            },

            show() {
                this.models = R.clone(this.jobModels)
                this.$refs.modal.show()
            }
        },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            jobModels: {
                type: Array,
                required: true
            },

            offerModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

            supplierModels: {
                type: Array,
                required: true
            },

            variantModels: {
                type: Array,
                required: true
            },

        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    .valid-until label {
        line-height: 2.6rem;
    }

    .valid-until .column {
        padding-left: 1.5rem !important;
        padding-right: 0 !important;
        margin-right: -1rem !important;
    }

</style>


